<script setup>
import {onMounted, ref} from 'vue'
import axios from 'axios'

const props = defineProps({
    data: {
        type: Object,
        required: false,
    },
})

onMounted(async () => {
    await getSponsors(sponsorsUrl)
})

const sponsorsUrl = 'api/sponsors'
const sponsors = ref([])
const backEndURL = process.env.VUE_APP_BACKEND_URL

const getSponsors = async url => {
    try {
        const res = await axios.get(`${backEndURL}/${url}`)
        sponsors.value = res.data
    } catch (err) {
        console.error(err)
    }
}

const filterByCategory = (sponsors, category) => {
    return sponsors.filter(sponsor => sponsor.type === category)
}

const linkTo = href => {
    window.open(href, '_blank')
}
</script>

<template>
    <section id="sponsors" class="bg-gray-50 py-10 sm:py-16">
        <div class="container mx-auto px-4 sm:px-6">
            <div class="max-w-3xl mx-auto text-center">
                <h1 class="font-heading mb-5 mt-2 text-3xl uppercase sm:mb-6 sm:text-4xl">SPONSORS</h1>
            </div>

            <!-- INTRODUCTION -->
            <div
                v-if="props.data && props.data.introduction_text.display"
                v-html="props.data.introduction_text.content"></div>

            <div
                v-if="props.data && props.data.our_sponsors_text && props.data.our_sponsors_text.display"
                v-html="props.data.our_sponsors_text.content"></div>

            <!-- MAIN SPONSORS -->
            <div
                v-if="props.data && props.data.main_sponsors_text.display"
                v-html="props.data.main_sponsors_text.content"></div>

            <div
                class="my-6 flex flex-col items-center gap-5 md:flex-row md:items-start"
                v-for="sponsor in filterByCategory(sponsors, 'MAIN').filter(s => s.display)"
                :key="sponsor.id">
                <img
                    @click="linkTo(sponsor.href)"
                    :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                    class="block h-48 w-full max-w-xs cursor-pointer object-scale-down sm:h-64 md:w-1/3" />
                <p class="max-w-xl px-0 py-2 text-left md:w-1/2">
                    {{ sponsor.description }}
                </p>
            </div>

            <!-- APERO SPONSORS -->
            <div
                v-if="props.data && props.data.apero_sponsors_text.display"
                v-html="props.data.apero_sponsors_text.content"></div>

            <div
                class="flex flex-wrap justify-center"
                v-for="sponsor in filterByCategory(sponsors, 'APERO').filter(s => s.display)"
                :key="sponsor.id">
                <div class="mb-2 mt-6 w-full max-w-xs px-4 sm:mt-8 sm:w-60 xl:mx-4 xl:w-1/4">
                    <a :href="sponsor.href" target="_blank">
                        <img
                            class="mx-auto block h-28 w-full object-scale-down sm:mb-12 sm:h-36"
                            :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                            :alt="sponsor.name" />
                    </a>
                </div>
            </div>

            <!-- DINNER SPONSORS -->
            <div
                v-if="props.data && props.data.dinner_sponsors_text.display"
                v-html="props.data.dinner_sponsors_text.content"></div>
            <div
                class="mx-auto mt-8 max-w-3xl text-center sm:mt-10"
                v-if="filterByCategory(sponsors, 'DINNER').some(s => s.display)">
                <h1 class="font-heading mb-5 mt-2 text-3xl sm:mb-6 sm:text-4xl">
                    {{ $t('sponsors.title_dinner') }}
                </h1>
            </div>
            <div
                class="flex flex-wrap justify-center"
                v-for="sponsor in filterByCategory(sponsors, 'DINNER').filter(s => s.display)"
                :key="sponsor.id">
                <div class="mb-2 mt-6 w-full max-w-xs px-4 sm:mt-8 sm:w-60 xl:mx-4 xl:w-1/4">
                    <a :href="sponsor.href" target="_blank">
                        <img
                            class="mx-auto block h-28 w-full object-scale-down sm:mb-8 sm:h-36"
                            :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                            :alt="sponsor.name" />
                    </a>
                </div>
            </div>

            <!-- EXHIBITION SPONSORS -->
            <div
                v-if="props.data && props.data.exhibition_sponsors_text.display"
                v-html="props.data.exhibition_sponsors_text.content"></div>

            <div
                class="flex flex-wrap justify-center"
                v-for="sponsor in filterByCategory(sponsors, 'EXHIBITION').filter(s => s.display)"
                :key="sponsor.id">
                <div class="mb-2 mt-6 w-full max-w-xs px-4 sm:mt-8 sm:w-60 xl:mx-4 xl:w-1/4">
                    <a :href="sponsor.href" target="_blank">
                        <img
                            class="mx-auto block h-28 w-full object-scale-down sm:mb-8 sm:h-36"
                            :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                            :alt="sponsor.name" />
                    </a>
                </div>
            </div>
        </div>
        <div
            class="container mx-auto px-4 sm:px-6"
            v-if="props.data && props.data.thank_you_text.display"
            v-html="props.data.thank_you_text.content"></div>
    </section>
</template>

<style scoped></style>
